import React from 'react';

const AlignTextJustifyIcon = props => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      stroke="none"
      fillRule="evenodd"
      transform="translate(-12.000000, -137.000000)"
      d="M12,137 L28,137 L28,139 L12,139 L12,137 Z M12,141 L28,141 L28,142 L12,142 L12,141 Z M12,144 L28,144 L28,146 L12,146 L12,144 Z M12,148 L28,148 L28,149 L12,149 L12,148 Z M12,151 L20,151 L20,153 L12,153 L12,151 Z"
    />
  </svg>
);

export default AlignTextJustifyIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/align-text-justify-icon.js